class Utils {
    constructor() {
        this.scrollDirection = 0; // 0 = scrollDown; 1 = scrollUp
        this.previousScrollPosition = 0;
        this.throttlePause = false;
    }

    getScrollDirection () {
        let scrollPosition = window.scrollY;

        if (scrollPosition > this.previousScrollPosition) {
            this.scrollDirection = 0
        } else {
            this.scrollDirection = 1
        }

        this.previousScrollPosition = scrollPosition;

        return this.scrollDirection;
    }

    throttle (callback, time) {
        //don't run the function if throttlePause is true
        if (this.throttlePause) return;
        //set throttlePause to true after the if condition. This allows the function to be run once
        this.throttlePause = true;

        //setTimeout runs the callback within the specified time
        setTimeout(() => {
            callback();

            //throttlePause is set to false once the function has been called, allowing the throttle function to loop
            this.throttlePause = false;
        }, time);
    }

    elementIsVisibleInViewport ( el, partiallyVisible = false ) {
        const { top, left, bottom, right } = el.getBoundingClientRect();
        const { innerHeight, innerWidth } = window;

        console.log (el, top, innerHeight)

        return partiallyVisible
            ? ((top > 0 && top < innerHeight) ||
                (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
            : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    }
}

export default Utils;
